// 用户中心
export const CSRF_ROOT_COOKIE_NAME = 'rootcsrftoken'
export const CSRF_ROOT_HEADER_NAME = 'X-Root-Csrf-Token'

export const DOCUMENT_CENTER = 'https://docs.threathunter.cn'

export const baseUrl =
  process.env.NODE_ENV === 'development' ? 'https://threathunter.cn/' : '' // https://wwwdytwnolpk3sgrwj0.yazx.com

export const karmaUrl =
  process.env.NODE_ENV === 'development' || window.location.host.includes('wwwdytwnolpk3sgrwj0')
    ? 'https://karmadytwnolpk3sgrwj0.yazx.com'
    : 'https://karma.threathunter.cn'
export default {
  CSRF_ROOT_COOKIE_NAME,
  CSRF_ROOT_HEADER_NAME,
  DOCUMENT_CENTER,
  baseUrl
}
